import React from "react";
import { Colors } from "../../utils/colors";
import { TCText } from "../TCText/TCText";
import { getCirclePlayerDescription } from "../../utils/utils";
import { observer } from "mobx-react-lite";
import { useSelectCircleStore } from "../../stores/StoreContext";
import back from "../../assets/back.png";
import forward from "../../assets/forward.png";
import { PlayerCircleGraphEnum } from "../../utils/data";

interface CircleSectionItemProps {
  id: number;
  index: number;
  onPrevClick: () => void;
  onNextClick: () => void;
}

export const CircleSectionItem: React.FC<CircleSectionItemProps> = observer(
  ({ id, index, onNextClick, onPrevClick }) => {
    const selectedCircleStore = useSelectCircleStore();
    return (
      <div
        style={{
          backgroundColor: Colors.gold,
          borderRadius: 12,
          cursor: "pointer",
          height: 40,
          width: 335,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingLeft: 15,
          paddingRight: 15,
        }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          {index > 0 && selectedCircleStore.selectedCircles.length > 1 ? (
            <img
              onClick={onPrevClick}
              src={back}
              alt=""
              style={{ height: 15, width: 10, marginRight: 15 }}
            />
          ) : null}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              justifyContent: "flex-start",
            }}>
            <TCText
              style={{ fontWeight: 600, fontSize: 12, color: Colors.green }}
              value={PlayerCircleGraphEnum.getTitle(id)}
            />
            <div
              style={{
                height: 15,
                width: 1,
                backgroundColor: Colors.green,
                marginTop: 2,
              }}
            />
            <TCText
              value={`(${PlayerCircleGraphEnum.getTotalPlayerCount(
                id,
                selectedCircleStore.circlePlayerResponse != null
                  ? selectedCircleStore.circlePlayerResponse
                  : undefined
              )}) ${getCirclePlayerDescription(id)}`}
              style={{
                fontSize: 10,
                fontWeight: 600,
                color: "black",
              }}
            />
          </div>
        </div>
        {index < selectedCircleStore.selectedCircles.length - 1 ? (
          <img
            onClick={onNextClick}
            src={forward}
            alt=""
            style={{ height: 15, width: 10, marginLeft: 10 }}
          />
        ) : null}
      </div>
    );
  }
);
